import { render, staticRenderFns } from "./PreviewHeaderLeftArea.vue?vue&type=template&id=2608b21a&"
import script from "./PreviewHeaderLeftArea.vue?vue&type=script&lang=ts&"
export * from "./PreviewHeaderLeftArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports